import React, {useEffect, useRef, useState} from 'react'
import {Box, makeStyles} from "@material-ui/core";
import VS from "constants/ValidationShema";
import Tr from "translations/Translations";
import TextInput from "components/TextInput";
import Form from "components/Form";
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import TemplateMemberFormField from "./TemplateMemberFormField";
import BoldTypography from "components/BoldTypography";
import SaveFormikValues from "components/SaveFormikValues";
import {PurchasingGroupTemplateFieldType} from "../../../../../templates/constants/PurchasingGroupTemplateFieldType";
import {connect} from "react-redux";
import {PurchasingGroupTemplateFormState} from "../constants/PurchasingGroupTemplateFormState";
import clsx from "clsx";
import Typography from "components/Typography";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import {PurchasingGroupRole} from "../../../../constants/PurchasingGroupRole";
import HistoryListPopup from "components/popup/historyListPopup/HistoryListPopup";
import HistoryButton from "components/button/HistoryButton";
import PurchasingGroupStage2Service from "services/PurchasingGroupStage2Service";
import propertyTransformer, {customParamTransformer} from "../history/propertyTransformer";
import moment from "moment";

const useStyle = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    marginLeft: {
        marginLeft: theme.spacing()
    },


    fieldGrid: {
        paddingBottom: theme.spacing(),
        paddingTop: theme.spacing(2),
        borderBottom: "solid 1px " + theme.palette.border.dark
    },
    fieldBox: {
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
    },
    fieldName: {
        fontSize: '0.75rem'
    },
    gridFieldComparing: {
        '&>.MuiGrid-item': {
            width: "50%"
        }
    },
    difference: {
        backgroundColor: theme.palette.warning.light
    },
    emptyValue: {
        color: theme.palette.action.disabled,
        fontStyle: "italic"
    }
}))

function TemplateMemberForm(
    {
        groupId,
        member,
        uxFormId,
        editable,
        coordinatorView,
        formWrapper,
        onDiscardChanges,
        onSubmit,
        formSubmit,
        purchasingGroupHeader
    }) {
    const classes = useStyle();
    const newForm = formWrapper.formId === 0;
    const formEditable = formWrapper.editable;
    const [submitter, setSubmitter] = useState(0);
    const [historyPopup, setHistoryPopup] = useState(false);
    const draftMode = useRef(false);

    const validationSchema = (allOptional) => {
        const getFieldVS = (field) => {
            switch (field.type) {
                case PurchasingGroupTemplateFieldType.NUMBER:
                    return VS.object({decimalValue: allOptional || !field.required ? VS.bigDecimalOptional() : VS.bigDecimal()})
                case PurchasingGroupTemplateFieldType.PERCENTAGE:
                    return VS.object({decimalValue: allOptional || !field.required ? VS.amountMax100Optional() : VS.amountMax100()})
                case PurchasingGroupTemplateFieldType.DATE:
                    return VS.object({textValue: allOptional || !field.required ? VS.dateTimeNoReq() : VS.dateTimeValid()})
                case PurchasingGroupTemplateFieldType.TEXT:
                    return VS.object({textValue: allOptional || !field.required ? VS.stringMaxNoRq(500) : VS.stringMax(500)})
                default:
                    return VS.any();
            }
        }
        return VS.object({
            purchaserName: VS.stringMax(250),
            fieldValues: VS.arrayOf(VS.lazy((value) => {
                return getFieldVS(value)
            }))
        })
    }

    useEffect(() => {
        if (submitter > 0)
            formSubmit[uxFormId]();
        // eslint-disable-next-line
    }, [submitter])

    const saveDraft = () => {
        draftMode.current = true;
        setSubmitter(submitter + 1);
    }

    const saveForm = () => {
        draftMode.current = false;
        setSubmitter(submitter + 1);
    }

    const getReadonlyNameField = () => {
        const difference = formWrapper.lastArchive ? formWrapper.form.purchaserName !== formWrapper.lastArchive.purchaserName : false;

        return (
            <>
                {
                    formWrapper.lastArchive &&
                    <GridBlock className={clsx(classes.fieldGrid, classes.gridFieldComparing)}>
                        <Box className={classes.fieldBox}>
                            <BoldTypography>{Tr("change_before")}</BoldTypography>
                        </Box>
                        <Box className={classes.fieldBox}>
                            <BoldTypography>{Tr("change_after")}</BoldTypography>
                        </Box>
                    </GridBlock>
                }
                <GridBlock className={clsx(classes.fieldGrid, {[classes.gridFieldComparing]: !!formWrapper.lastArchive, [classes.difference]: difference})}>
                    {!!formWrapper.lastArchive && getViewNameField(formWrapper.lastArchive.purchaserName)}
                    {getViewNameField(formWrapper.form.purchaserName)}
                </GridBlock>
            </>)
    }

    const getViewNameField = (value) => {
        return <Box className={classes.fieldBox}>
            <Typography className={classes.fieldName}>{Tr("name")}</Typography>
            <Typography>{value}</Typography>
        </Box>
    }
    const loadHistoryList = async () => {
        try {
            return await PurchasingGroupStage2Service.getArchiveList(groupId, member.memberId, formWrapper.formId)
        } catch (e) {
            setHistoryPopup(false);
        }
    }

    const loadHistoryElement = async (archiveId) => {
        return await PurchasingGroupStage2Service.getArchiveElement(groupId, member.memberId, formWrapper.formId, archiveId);
    }

    return (<div className={classes.root}>
        <Form
            id={uxFormId}
            initialValues={{
                purchaserName: formWrapper.form.purchaserName,
                fieldValues: formWrapper.form.fieldValues.map(field => field.type === PurchasingGroupTemplateFieldType.DATE ? {
                ...field,
                textValue: !field.textValue ? null : moment(field.textValue)
            } : field)
            }}
            validationSchema={validationSchema(draftMode.current)}
            onSubmit={(values) => onSubmit(draftMode.current ? "draft" : "save", values)}>
            {(formikProps) => (<>
                <SaveFormikValues
                    formikProps={formikProps}
                    id={uxFormId}
                />
                {
                    (formWrapper.hasAskedForEdit && !formWrapper.editable) && <BoldTypography>{Tr("purchase_groups_form_ask_edit")}</BoldTypography>
                }
                <GridBlock justify="space-between">
                    {newForm ? <BoldTypography variant="h6">Nowy formularz</BoldTypography> : <div></div>}
                    <div>
                        {
                            !newForm &&  <HistoryButton onClick={() => setHistoryPopup(true)}>
                                {Tr('change_history')}
                            </HistoryButton>
                        }

                        {
                            formWrapper.canAskForEdit && <Button className={classes.marginLeft}
                                                                 onClick={() => onSubmit("askForEdit")}
                                                                 variant="outlined">{Tr("purchasing_group_form_ask_for_edit")}</Button>
                        }

                        {
                            (purchasingGroupHeader.userRole === PurchasingGroupRole.ADMIN && formWrapper.form.state === PurchasingGroupTemplateFormState.ASK_FOR_EDIT) && <>
                                <Button className={classes.marginLeft} onClick={() => onSubmit("allowEdit")}>{Tr("purchasing_group_form_edit_allow_edit")}</Button>
                                <Button className={classes.marginLeft} onClick={() => onSubmit("rejectEdit")} variant="outlined">{Tr("purchasing_group_form_edit_reject_edit")}</Button>
                            </>
                        }

                        {
                            formEditable &&
                            <Button className={classes.marginLeft} disabled={!(newForm || formikProps.dirty)} onClick={onDiscardChanges}
                                    variant="outlined">{Tr("discard_changes")}</Button>
                        }
                        {
                            !coordinatorView && editable && formWrapper.form.state === PurchasingGroupTemplateFormState.SENT && <>
                                <Button className={classes.marginLeft} onClick={() => onSubmit("accept")}>{Tr("accept")}</Button>
                                <Button className={classes.marginLeft} onClick={() => onSubmit("reject")} variant="outlined">{Tr("reject")}</Button>
                            </>
                        }

                        {(coordinatorView && formEditable && formWrapper.form.state !== PurchasingGroupTemplateFormState.EDIT) && <Button className={classes.marginLeft} disabled={!(newForm || formikProps.dirty)}
                                                    onClick={() => saveDraft(formikProps)} variant="outlined">{Tr("save_draft_version")}</Button>
                        }
                        {(coordinatorView && formEditable) && formWrapper.hasDraftSaved &&
                            <Button className={classes.marginLeft} onClick={() => onSubmit("clearDraft")}
                                    variant="outlined">{Tr("delete_draft_version")}</Button>
                        }
                        {formEditable &&
                            <Button onClick={() => saveForm(formikProps)} className={classes.marginLeft}>{Tr(coordinatorView ? "send" : "save")}</Button>}
                    </div>
                </GridBlock>



                {
                    formEditable ?
                        <TextInput
                            id="purchaserName"
                            formikProps={formikProps}
                            required
                            multiline
                            label={Tr("name")}
                            disabled={!formEditable}
                        /> : getReadonlyNameField()
                }


                {
                    formWrapper.form.fieldValues.map((field, i) =>
                        <TemplateMemberFormField
                            key={field.identity}
                            id={`fieldValues.${i}`}
                            formikProps={formikProps}
                            enabled={formEditable}
                            lastArchiveField={formWrapper.lastArchive ? formWrapper.lastArchive.fieldValues.find(x => x.identity === field.identity) : undefined}
                            classes={classes}
                        />)
                }

            </>)}
        </Form>
        {historyPopup && <HistoryListPopup loadHistoryElement={loadHistoryElement} loadHistoryList={loadHistoryList} onClose={() => setHistoryPopup(false)}
                                        propertyTransformer={propertyTransformer(formWrapper.form)} customParamTransformer={customParamTransformer}/>}
    </div>)
}

TemplateMemberForm.propTypes = {}

export default connect((state) => ({
    purchasingGroupHeader: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_HEADER_RESOURCE_ID],
    formSubmit: state.form
}), {})(TemplateMemberForm);